import { SegmentRepo } from "@/repos";
import { pageSize } from '@/configs/api.config'

const perPage = pageSize || 10;

class SegmentService {
    async list(params) {
        params = params || {};
        params['page_size'] = params['page_size'] || perPage;

        let { data } = await SegmentRepo.list(params);
        data.page = params.page || 1;
        data.totalPage = Math.ceil(data.count / params['page_size']);

        return data;
    }

    async get(id) {
        let { data } = await SegmentRepo.get(id);
        return data;
    }

    async create(user) {
        let { data } = await SegmentRepo.create(user);
        return data;
    }
    
    async update(id, user) {
        let { data } = await SegmentRepo.update(id, user);
        return data;
    }

    async delete(id) {
        let { data } = await SegmentRepo.delete(id);
        return data;
    }

    async setUsers(id, users) {
        let { data } = await SegmentRepo.setUsers(id, users);
        return data;
    }
}

export default new SegmentService();